import { orderByField } from 'components/common/Deal/ListOfFiles/ListOfFiles';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import { SortDir, SortSettings } from 'components/common/types/SortDir.types';
import CollapsibleList from 'lib/CollapsibleList';
import CollapsibleListStatsHeader from 'lib/CollapsibleList/CollapsibleListStatsHeader';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import FetchedOptionsList from '../FetchedOptionsList/FetchedOptionsList';

export type FetchedOptionsCollapsibleProps = {
  onToggleCategory: React.Dispatch<React.SetStateAction<string>>;
  openCategories: string[];
  fetchedOptions: RouteFrameCode[];
  onOptionIncludeExcludeChange: (routeFrameCode: RouteFrameCode) => void;
  isOptionIncluded: (code: string, mediaOwner?: string) => boolean | undefined;
  isOptionSelected: (code: string, mediaOwner?: string) => boolean;
};

const FetchedOptionsCollapsible: React.FC<FetchedOptionsCollapsibleProps> = ({
  fetchedOptions,
  onOptionIncludeExcludeChange,
  isOptionIncluded,
  isOptionSelected,
  onToggleCategory,
  openCategories,
}) => {
  const [sortDirection, setSortDirection] = useState(SortDir.ASC);
  const [fetchedRouteFrameCodes, setFetchedRouteFrameCodes] = useState(fetchedOptions);

  useEffect(() => {
    setFetchedRouteFrameCodes(fetchedOptions);
  }, [fetchedOptions]);

  const onCategoryDirectionSort = (direction: SortDir): void => {
    const routeFrameCodes = cloneDeep(fetchedOptions);

    setSortDirection(SortSettings[sortDirection].nextDir);

    if (!routeFrameCodes) return;

    const sorted = orderByField(routeFrameCodes, 'name', direction);

    setFetchedRouteFrameCodes(sorted);
  };

  return (
    <CollapsibleList
      label="Search results"
      isSortVisible
      sortDir={sortDirection}
      onSort={onCategoryDirectionSort}
      isOpen={openCategories.includes('Results')}
      onToggle={() => onToggleCategory('Results')}
      isClearAllVisible={false}
      key="format-category-searched-results-frame-list"
      headerComponent={
        <CollapsibleListStatsHeader available={fetchedRouteFrameCodes.length} included={0} excluded={0} />
      }
    >
      {fetchedRouteFrameCodes.map(({ code, name, mediaOwner }: RouteFrameCode) => {
        return (
          <FetchedOptionsList
            key={`fetched-option-${code}-${mediaOwner}`}
            code={code}
            name={name}
            mediaOwner={mediaOwner}
            onOptionIncludeExcludeChange={onOptionIncludeExcludeChange}
            isOptionIncluded={isOptionIncluded}
            isOptionSelected={isOptionSelected}
          />
        );
      })}
    </CollapsibleList>
  );
};

export default FetchedOptionsCollapsible;
